import _                from 'lodash'
import PropTypes        from 'prop-types'
import React            from 'react'
import { Nav, NavItem } from 'react-bootstrap'

import { formatDate   } from 'alto-utils/lib/utils'
import { menuSetting  } from 'alto-react-canteen/lib/settings'

export default class DateSelection extends React.Component
  @contextTypes = { settings: PropTypes.object }

  constructor: (props, context) ->
    super(props, context)

    @showWithoutMeals = menuSetting(@context.settings).showDaysWOMeals

  render: ->
    <Nav justified className="menu-date-selection" bsStyle="pills" onSelect={@props.onSelect}>
      {@props.menu.dates().map(@dateNavFor)}
    </Nav>

  dateNavFor: (date) =>
    localized  = date.locale('cs')
    weekDay    = _.capitalize(localized.format('dddd'))
    monthDay   = localized.format('D. MMMM')
    dailyMenu  = @props.menu.dailyMenuFor(date)
    isSelected = @props.selectedDate.isSame(date)
    hasMeals   = dailyMenu.hasMeals()
    showMarker = _.isFunction(dailyMenu.isSaved) and not dailyMenu.isSaved()

    if @showWithoutMeals or hasMeals
      <NavItem key={formatDate(date)} eventKey={date} active={isSelected} disabled={not hasMeals}>
        {weekDay}<br />{monthDay}
        {<span className='dot'>&bull;</span> if showMarker}
      </NavItem>
